$(document).ready(function () {
  
   if (window.location.href.indexOf("#subscribe") !== -1) {
     setTimeout(function() {
        $('product-info .subscribe_purchase_btn').trigger('click');
     },800);
    }
  $('.footer-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: false,
    autoplay: true,  
    autoplaySpeed: 2000,  
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  
  $('.slick-products-grid').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    arrows: true,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

 

  $('.mean-weare-responsive').slick({
    dots: false,
    infinite: true,
    speed: 5000,   
    slidesToShow: 4,  
    slidesToScroll: 1,  
    autoplay: true,
    autoplaySpeed: 0,   
    cssEase: "linear",   
    variableWidth: false,   
    pauseOnHover: false,   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,  
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, 
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1, 
          slidesToScroll: 1
        }
      }
    ]
  });

 
  // $('.play_audio').on('click', function(e) {
  //   e.preventDefault();
  //   $('#videoModal').modal('show');
  // });
//   $('.play_audio').on('click', function(e) {
//     e.preventDefault();
//     var video = $('#videoModal video')[0]; // Select video inside modal

//     $('#videoModal').modal('show');

//     if (video) {
//         video.muted = true; // Ensure it's muted (needed for autoplay on mobile)
//         video.play();
//     }
// });
// jQuery(document).ready(function ($) {
//     $('.play_audio').on('click', function (e) {
//         e.preventDefault();

//         var video = $('#videoModal video')[0]; // Select video inside modal

//         // Use Bootstrap 5's modal method
//         var modal = new bootstrap.Modal(document.getElementById('videoModal'));
//         modal.show();

//         if (video) {
//             video.muted = true; // Ensure it's muted (needed for autoplay on mobile)
//             video.play();
//         }
//     });
// });

// // Pause and reset video when modal is closed
// $('#videoModal').on('hidden.bs.modal', function () {
//     var video = $(this).find('video')[0];
//     if (video) {
//         video.pause();
//         video.currentTime = 0;
//     }
// });


//   const myModalEl = document.getElementById('videoModal');
// if(myModalEl) {
//   myModalEl.addEventListener('hidden.bs.modal', event => {
//     // Find the video inside the modal and pause it
//     let video = myModalEl.querySelector('video');
//     if (video) {
//       video.pause();  // Pause the video
//       video.currentTime = 0; // Reset to beginning
//     }
//   });
// }
// Using jQuery to handle the opening of the modal and video play
jQuery(document).ready(function ($) {
    $('.play_audio').on('click', function (e) {
        e.preventDefault();

        var video = $('#videoModal video')[0]; // Select video inside modal

        // Use Bootstrap 5's modal method to show the modal
        var modal = new bootstrap.Modal(document.getElementById('videoModal'));
        modal.show();

        if (video) {
            video.muted = true; // Ensure it's muted (needed for autoplay on mobile)
            video.play();
        }
    });

    // Pause and reset video when modal is closed using jQuery
    $('#videoModal').on('hidden.bs.modal', function () {
        var video = $(this).find('video')[0];
        if (video) {
            video.pause();
            video.currentTime = 0; // Reset to beginning
        }

        // Also handle iframe (e.g., YouTube or Vimeo) video/audio
        var iframe = $(this).find('iframe')[0];
        if (iframe) {
            var iframeSrc = iframe.src;
            iframe.src = ""; // Temporarily remove the iframe source to stop the video/audio
            iframe.src = iframeSrc; // Reset the iframe source to resume the video/audio
        }
    });
});

// Using vanilla JavaScript to ensure consistency
const myModalEl = document.getElementById('videoModal');
if (myModalEl) {
    myModalEl.addEventListener('hidden.bs.modal', event => {
        // Find the video inside the modal and pause it
        let video = myModalEl.querySelector('video');
        if (video) {
            video.pause();  // Pause the video
            video.currentTime = 0; // Reset to beginning
        }

        // Handle iframe (e.g., YouTube or Vimeo) video/audio
        let iframe = myModalEl.querySelector('iframe');
        if (iframe) {
            let iframeSrc = iframe.src;
            iframe.src = ""; // Temporarily remove the iframe source to stop the video/audio
            iframe.src = iframeSrc; // Reset the iframe source to resume the video/audio when reopened
        }
    });

    // Ensure modal close also resets iframe (if used) and stops audio/video
    myModalEl.addEventListener('click', function (event) {
        if (event.target === event.currentTarget) {
            var iframe = myModalEl.querySelector('iframe');
            if (iframe) {
                var iframeSrc = iframe.src;
                iframe.src = ""; // Temporarily remove the iframe source to stop the video/audio
                iframe.src = iframeSrc; // Reset the iframe source to resume the video/audio
            }
        }
    });
}


  // $('.subscribe_purchase_btn').on('click',function(e) {
  //   e.preventDefault();
  //   $('.subscription_options').show();
  //   var selected_subscription_plan = $('.subscription_options select').val();
  //   // $('#shopify-block-ARXZlbFUwTHFIaExCS__subscriptions_app_block_n8Tx3n').find('input[data-radio-type="selling_plan"][data-selling-plan-id="'+selected_subscription_plan+'"]').prop('checked',true);
  //   $('.sealsubs-target-element').find('input[data-type="subscription"]').trigger('click');
  //   $('.sealsubs-target-element').find('select[name="subs_interval"]').val(selected_subscription_plan);
  //   $('.sealsubs-target-element').find('select[name="subs_interval"] option[value="'+selected_subscription_plan+'"]').prop('selected', true);
  //   $('main>section:first').hide();
  //   $('.subscribe_purchase_btn').addClass('active');
  //   $('.single_purchase_btn').removeClass('active');
  // });
  $('.subscribe_purchase_btn').on('click',function(e) {
  e.preventDefault();
  $('.subscription_options').show();

  var selected = $('.subscription_options select option:selected');
  var selected_subscription_plan = selected.val(); // plan.id
  var selected_interval = selected.data('interval') || selected_subscription_plan;

  $('.sealsubs-target-element').find('input[data-type="subscription"]').trigger('click');
  $('.sealsubs-target-element').find('select[name="subs_interval"]').val(selected_interval);
  $('.sealsubs-target-element').find('select[name="subs_interval"] option[value="'+selected_interval+'"]').prop('selected', true);

  /* NOTE: removed `$('main>section:first').hide();` — it hid the entire PDP
     section (the first <section> in <main>), causing the page to collapse/scroll
     and the product to disappear instead of selecting the subscribe option. */
  $('.subscribe_purchase_btn').addClass('active');
  $('.single_purchase_btn').removeClass('active');
});

  $('.single_purchase_btn').on('click',function(e) {
    e.preventDefault();
    $('.subscription_options').hide();
    $('.sealsubs-target-element').find('input[data-type="one_time"]').trigger('click');
    /* NOTE: removed `$('main>section:first').show();` — paired with the hide()
       removed above; no longer needed since we never hide the PDP. */
     $(this).addClass('active');
    $('.subscribe_purchase_btn').removeClass('active');
  });
//   $('.subscription_options select').on('change', function(e) {
//   e.preventDefault();

//   var selected = $(this).find('option:selected');
//   var selected_plan_id = selected.val(); // <-- this is plan.id
//   var selected_interval = selected.data('interval'); // just for display/logging

//   console.log("Selected interval: " + selected_interval + " | Plan ID: " + selected_plan_id);

//   // Pass correct plan.id to Seal app
//   $('.sealsubs-target-element')
//     .find('select[name="subs_interval"]')
//     .val(selected_plan_id);

//   $('.sealsubs-target-element')
//     .find('select[name="subs_interval"] option[value="'+selected_plan_id+'"]')
//     .prop('selected', true);
// });

$('.subscription_options select').on('change', function(e) {
  e.preventDefault();

  var selected = $(this).find('option:selected');
  var selected_plan_id = selected.val();   // Seal plan.id
  var selected_interval = selected.data('interval');

  console.log("Selected interval: " + selected_interval + " | Plan ID: " + selected_plan_id);

  var sealSelect = $('.sealsubs-target-element').find('select[name="subs_interval"]');

  // set value
  sealSelect.val(selected_plan_id);

  // force option selected
  sealSelect.find('option[value="'+selected_plan_id+'"]').prop('selected', true);

  // IMPORTANT: trigger native change event (not just jQuery)
  const nativeChange = new Event('change', { bubbles: true });
  sealSelect[0].dispatchEvent(nativeChange);

  // also trigger click for safety
  sealSelect.trigger('click');
});


  // $('.subscription_options select').on('change',function(e) {
  //   // alert();
  //   e.preventDefault();
  //   var selected = $(this).find('option:selected');
  // var selected_interval = selected.data('interval') || selected.val();
  // alert(selected_interval);
  //  $('.sealsubs-target-element').find('select[name="subs_interval"]').val(selected_interval);
  //   $('.sealsubs-target-element').find('select[name="subs_interval"] option[value="'+selected_interval+'"]').prop('selected', true);

  //   // var selected_subscription_plan = $(this).val();
  //   // // $('#shopify-block-ARXZlbFUwTHFIaExCS__subscriptions_app_block_n8Tx3n').find('input[data-radio-type="selling_plan"][data-selling-plan-id="'+selected_subscription_plan+'"]').prop('checked',true);
  //   // $('.sealsubs-target-element').find('select[name="subs_interval"]').val(selected_subscription_plan);
  //   // $('.sealsubs-target-element').find('select[name="subs_interval"] option[value="'+selected_subscription_plan+'"]').prop('selected', true);
  // }); 
});


 

// $('.subscription_options select').on('change',function(e) {
//   e.preventDefault();

  // var selected = $(this).find('option:selected');
  // var selected_interval = selected.data('interval') || selected.val();

  // $('.sealsubs-target-element').find('select[name="subs_interval"]').val(selected_interval);
  // $('.sealsubs-target-element').find('select[name="subs_interval"] option[value="'+selected_interval+'"]').prop('selected', true);
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const articleCards = document.querySelectorAll(".article-card");

//   articleCards.forEach((card) => {
//     card.addEventListener("click", function () { 
//       const title = this.getAttribute("data-title");
//       const image = this.getAttribute("data-image");
//       const excerpt = this.getAttribute("data-excerpt");
//       const date = this.getAttribute("data-date");
//       const author = this.getAttribute("data-author");
//       const imageurl = this.getAttribute("data-url");
//       const parentId = this.getAttribute("data-parent");  
//       const targetCard = document.querySelector(`#${parentId}-details-card`); 
 
//       const targetTitle = targetCard.querySelector("#card-title");
//       const targetDate = targetCard.querySelector("#card-date");
//       const targetAuthor = targetCard.querySelector("#card-author");
//       const targetImage = targetCard.querySelector("#card-image");
//       const targetExcerpt = targetCard.querySelector("#card-excerpt");
//       const targetLink = targetCard.parentElement;  
//       if (targetTitle) targetTitle.textContent = title;
//       if (targetDate) targetDate.textContent = date;
//       if (targetAuthor) targetAuthor.textContent = author;
//       if (targetImage) targetImage.src = image;
//       if (targetExcerpt) targetExcerpt.textContent = excerpt;
//       if (targetLink) targetLink.href = imageurl;
//     });
//   });
// });



setInterval(function () {
  document.querySelectorAll(".seal-button[data-subscription='true']").forEach((button) => {
    if (button.innerText.trim() === "Add") {
      button.innerText = "Add to Subscription";
    }
  });
}, 500);
document.addEventListener("DOMContentLoaded", function () {
  function updateButtonText() {
    document.querySelectorAll(".seal-edit-button[data-action='skip']").forEach((button) => {
      if (button.innerText.trim() === "Skip payment") {
        button.innerText = "Skip Delivery";
      }
    });
  }

  updateButtonText();  

  
  const observer = new MutationObserver(updateButtonText);
  observer.observe(document.body, { childList: true, subtree: true });
});

$('.seal-subscription-page .seal-medium .seal-subdued').each(function(index) {
  if (index === 0) {
    $(this).text('Upcoming').css('background', '#B1E8D3');
  } else {
    $(this).text('Scheduled');
  }
});


$('.list-menu li header-menu details').hover(
  function(event) {
    // When entering a menu, immediately close all other menus.
    $('.list-menu li header-menu details').each(function() {
      if (this !== event.currentTarget) {
        // Clear any pending leave timers for other menus.
        clearTimeout($(this).data('leaveTimer'));
        $(this).removeData('leaveTimer');
        // Close the menu.
        $(this).removeAttr('open');
        $(this).find('summary').attr('aria-expanded', 'false');
      }
    });
    // Clear any timer for the current menu (if exists).
    clearTimeout($(this).data('leaveTimer'));
    $(this).removeData('leaveTimer');
    // Open the current menu.
    $(this).attr('open', '');
    $(this).find('summary').attr('aria-expanded', 'true');
  },
  function() {
    var $this = $(this);
    // Set a delay for closing the menu.
    var timer = setTimeout(function() {
      $this.removeAttr('open');
      $this.find('summary').attr('aria-expanded', 'false');
    }, 300); // Adjust delay as needed.
    $this.data('leaveTimer', timer);
  }
);

// document.addEventListener("DOMContentLoaded", function() {
//   const banners = document.querySelectorAll(".account-banner");

//   window.addEventListener("scroll", function() {
//     // Set the scroll threshold (in pixels)
//     const threshold = 100;

//     banners.forEach(banner => {
//       if (window.scrollY > threshold) {
//         banner.classList.add("sticky-banner");
//       } else {
//         banner.classList.remove("sticky-banner");
//       }
//     });
//   });
// });



  // document.addEventListener("DOMContentLoaded", function () {
  //   console.log("✅ Script Loaded!");

  //   // Scroll to footer if form_type=customer
  //   setTimeout(() => {
  //     const currentURL = window.location.href;
  //     const currentHash = window.location.hash;

  //     if (currentURL.includes("form_type=customer") || currentHash === "#FooterNewsletter") {
  //       console.log("🚀 Scrolling to footer...");
  //       const footerNewsletter = document.querySelector("#FooterNewsletter");

  //       if (footerNewsletter) {
  //         footerNewsletter.scrollIntoView({ behavior: "smooth", block: "end" });
  //       } else {
  //         window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  //       }
  //     }
  //   }, 1500);

  //   // ✅ MutationObserver to detect success/error messages
  //   const observer = new MutationObserver((mutations) => {
  //     mutations.forEach((mutation) => {
  //       if (mutation.addedNodes.length) {
  //         const successMessage = document.querySelector(".newsletter-form__message--success");
  //         const errorMessage = document.querySelector(".newsletter-form__message.form__message");

  //         if (successMessage) {
  //           showCustomMessage("✅ Subscription Successful!", "success");
  //         } else if (errorMessage) {
  //           showCustomMessage("❌ Subscription Failed! Please try again.", "error");
  //         }
  //       }
  //     });
  //   });

  //   // Observe the newsletter form container
  //   const formContainer = document.querySelector(".newsletter__wrapper");
  //   if (formContainer) {
  //     observer.observe(formContainer, { childList: true, subtree: true });
  //   }

  //   // ✅ Function to show message below input
  //   function showCustomMessage(message, type) {
  //     const inputField = document.querySelector(".input.field__input"); // Newsletter input field
  //     if (!inputField) return; // Agar input field nahi mila toh return

  //     // Remove old message if exists
  //     const oldMessage = document.querySelector(".custom-alert");
  //     if (oldMessage) oldMessage.remove();

  //     // Create new message div
  //     const alertBox = document.createElement("div");
  //     alertBox.className = `custom-alert ${type}`;
  //     alertBox.textContent = message;

  //     // Insert message below input field
  //     inputField.insertAdjacentElement("afterend", alertBox);

  //     // Remove after 3 seconds
  //     setTimeout(() => {
  //       alertBox.remove();
  //     }, 3000);
  //   }
  // });



  // document.addEventListener("DOMContentLoaded", function () {
  //   console.log("✅ Script Loaded!"); // Ye check karega ki script load ho rahi hai ya nahi

  //   setTimeout(() => {
     
  //     const currentURL = window.location.href;
  //     const currentHash = window.location.hash;
  
  //     if (currentURL.includes("form_type=customer") || currentHash === "#FooterNewsletter") {
  //       console.log("🚀 Scrolling to footer...");

        
  //       const footerNewsletter = document.querySelector("#FooterNewsletter");

  //       if (footerNewsletter) {
  //         footerNewsletter.scrollIntoView({ behavior: "smooth", block: "end" });
         
  //       } else {
  //         window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
        
  //       }
  //     } else {
  //       console.log("ℹ️ No match found for form_type=customer or #FooterNewsletter");
  //     }
  //   }, 1500);
  // });


document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ Script Loaded!");

  // Scroll to footer if form_type=customer
  setTimeout(() => {
    const currentURL = window.location.href;
    const currentHash = window.location.hash;

    if (currentURL.includes("form_type=customer") || currentHash === "#FooterNewsletter") {
      console.log("🚀 Scrolling to footer...");
      const footerNewsletter = document.querySelector("#FooterNewsletter");

      if (footerNewsletter) {
        footerNewsletter.scrollIntoView({ behavior: "smooth", block: "end" });
      } else {
        window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
      }
    }
  }, 1500);

 
 
 
});

 document.addEventListener("DOMContentLoaded", function () {
    let currentURL = window.location.href;  
    let currentHash = window.location.hash;  

    let successMessage = document.getElementById("newsletterSuccessMessage");

    if (successMessage) {
        if (currentURL.includes("form_type=customer") || currentHash === "#FooterNewsletter") {
            successMessage.style.display = "flex";
        } else {
            successMessage.style.display = "none";
        }
    }
});

/* ===========================================================
   Sticky mobile Add-to-Cart bar (mobile only; CSS gates ≤749px).
   Reuses the real ATC button (cloned) so the same form / variant /
   selling plan is submitted. Appears once the real ATC scrolls away.
   =========================================================== */
document.addEventListener("DOMContentLoaded", function () {
  var realAtc = document.querySelector('.product__info-wrapper .product-form__submit');
  if (!realAtc) return; // product pages only

  var priceEl = document.querySelector('.product__info-wrapper .price__regular .price-item')
             || document.querySelector('.product__info-wrapper .price .price-item');
  var titleMeta = document.querySelector('meta[property="og:title"]');
  var title = (titleMeta && titleMeta.content) || (document.title.split('–')[0] || '').trim();

  var bar = document.createElement('div');
  bar.className = 'ng-sticky-atc';

  var info = document.createElement('div');
  info.className = 'ng-sticky-atc__info';
  var titleEl = document.createElement('span');
  titleEl.className = 'ng-sticky-atc__title';
  titleEl.textContent = title;
  var priceSpan = document.createElement('span');
  priceSpan.className = 'ng-sticky-atc__price';
  if (priceEl) priceSpan.textContent = priceEl.textContent.trim();
  info.appendChild(titleEl);
  info.appendChild(priceSpan);

  // Clone the real ATC button for identical styling; trigger the original on click
  var btn = realAtc.cloneNode(true);
  btn.setAttribute('type', 'button');
  btn.removeAttribute('name');
  btn.removeAttribute('id');
  btn.classList.add('ng-sticky-atc__btn');
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    realAtc.click();
  });

  bar.appendChild(info);
  bar.appendChild(btn);
  document.body.appendChild(bar);

  // Keep the sticky price in sync with the live price (variant / subscribe changes)
  if (priceEl) {
    var sync = function () { priceSpan.textContent = priceEl.textContent.trim(); };
    new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  // Show the bar only when the real ATC is out of view
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('is-visible', !en.isIntersecting);
      });
    }, { threshold: 0 }).observe(realAtc);
  }
});

/* ===========================================================
   Star radio indicator on the Single / Subscribe purchase cards.
   A real <span> (not ::before) is prepended to each button — Dawn's
   base .button::before is suppressed (opacity/transform) and can't be
   used reliably. CSS styles .ng-radio-star (hollow ⭢ filled on .active).
   =========================================================== */
document.addEventListener("DOMContentLoaded", function () {
  ['.single_purchase_btn', '.subscribe_purchase_btn'].forEach(function (sel) {
    document.querySelectorAll('.product__info-wrapper ' + sel).forEach(function (btn) {
      if (btn.querySelector('.ng-radio-star')) return;
      var star = document.createElement('span');
      star.className = 'ng-radio-star';
      star.setAttribute('aria-hidden', 'true');
      btn.insertBefore(star, btn.firstChild);
    });
  });
});


